module.exports = __webpack_public_path__ + "img/省级地质灾害应急指挥系统.95b1855e.jpg";